import {combineReducers} from 'redux';

import applicationMessageReducers from './applicationMessageReducers';
import architectReducers from './architectReducers';
import attributeManagementReducers from './attributeManagementReducers';
import authReducers from './authReducers';
import basAgentReducers from './basAgentReducers';
import bobReducers from './bobReducers';
import clientReducers from './clientReducers';
import communicationReducers from './communicationReducers';
import companyInfoReducers from './companyInfoReducers';
import companyManagementReducers from './companyManagementReducers';
import contactReducers from './contactReducers';
import conversionReducers from './conversionReducers';
import currentUserReducers from './currentUserReducers';
import coreReducers from './coreReducers';
import configurationReducers from './configurationReducers';
import dashboardReducers from './dashboardReducers';
import workerReducer from './workerReducers';
import deviceReducers from './deviceReducers';
import energyReducers from './energyReducers';
import erpAgentReducers from './erpAgentReducers';
import equipmentTypeReducers from './equipmentTypeReducers';
import executiveSummaryReducers from './executiveSummaryReducers';
import homeReducers from './homeReducers';
import inventoryReducers from './inventoryReducers';
import iotHubReducers from './iotHubReducers';
import jobReducers from './jobReducers';
import k2aCoreReducers from './k2aCoreReducers';
import knowiReducers from './knowiReducers';
import lookupReducers from './lookupReducers';
import profileReducers from './profileReducers';
import profileObjectReducers from './profileObjectReducers';
import reportingReducers from './reportingReducers';
import roleReducers from './roleReducers';
import ruleReducers from './ruleReducers';
import sensorDataReducers from './sensorDataReducers';
import scoringReducers from './scoringReducers';
import sensorTypeReducers from './sensorTypeReducers';
import serviceManagementReducers from './serviceManagementReducers';
import svcRequestReducers from './svcRequestReducers';
import siteReducers from './siteReducers';
import subscriptionReducers from './subscriptionReducers';
import systemTypeReducers from './systemTypeReducers';
import tableReducers from './tableReducers';
import uiReducers from './uiReducers';
import weatherReducers from './weatherReducers';
import webSocketReducers from './webSocketReducers';
import wizardReducers from './wizardReducers';
import schedulerReducers from './schedulerReducers';

export default combineReducers({
    architect:           architectReducers,
    attributeManagement: attributeManagementReducers,
    auth:                authReducers,
    basAgent:            basAgentReducers,
    bob:                 bobReducers,
    client:              clientReducers,
    companyManagement:   companyManagementReducers,
    contact:             contactReducers,
    conversion:          conversionReducers,
    communications:      communicationReducers,
    companyInfo:         companyInfoReducers,
    configurationData:   configurationReducers,
    currentUser:         currentUserReducers,
    core:                coreReducers,
    dashboard:           dashboardReducers,
    device:              deviceReducers,
    energy:              energyReducers,
    equipmentTypes:      equipmentTypeReducers,
    erpAgent:            erpAgentReducers,
    executiveSummary:    executiveSummaryReducers,
    home:                homeReducers,
    inventory:           inventoryReducers,
    iotHub:              iotHubReducers,
    job:                 jobReducers,
    k2aCore:             k2aCoreReducers,
    knowi:               knowiReducers,
    lookup:              lookupReducers,
    messages:            applicationMessageReducers,
    profile:             profileReducers,
    profileObjects:      profileObjectReducers,
    reporting:           reportingReducers,
    roles:               roleReducers,
    rules:               ruleReducers,
    sensorData:          sensorDataReducers,
    scoring:             scoringReducers,
    sensorTypes:         sensorTypeReducers,
    site:                siteReducers,
    subscription:        subscriptionReducers,
    svcManagement:       serviceManagementReducers,
    svcRequest:          svcRequestReducers,
    systemTypes:         systemTypeReducers,
    tableProps:          tableReducers,
    ui:                  uiReducers,
    webSocket:           webSocketReducers,
    wizard:              wizardReducers,
    scheduler:           schedulerReducers,
    weather:             weatherReducers,
    worker:              workerReducer
});
